import { TRANSFORMERS, Transformer } from '@lexical/markdown';
import { LexicalEditor } from 'lexical';
import { createHtmlTransformer } from './html';
import { INLINE_SUGGESTION } from './inline-suggestions';
import { createSuggestionTransformer } from './suggestion';
import { createTableTransformer } from './table';

export const createTransformers = (editor: LexicalEditor): Transformer[] => {
  const baseTransformers = [...TRANSFORMERS, INLINE_SUGGESTION];
  const tableTransformer = createTableTransformer(baseTransformers);
  const suggestionTransformer = createSuggestionTransformer(baseTransformers);
  const htmlTransformer = createHtmlTransformer(editor);

  return [suggestionTransformer, htmlTransformer, tableTransformer, ...baseTransformers];
};
